import VideoCarousel from "@/components/VideoCarousel";
import { SHOWREEL } from "@/data/portfolio";

export default function Showreel() {
  return (
    <VideoCarousel
      id="work"
      sectionTestId="showreel-section"
      testIdPrefix="showreel"
      eyebrow="Reaction Edits"
      headingPrimary="Reaction"
      headingItalic="edits"
      description="A carousel of recent reaction edits — movies, TV shows, season finales. Click any tile to watch."
      videos={SHOWREEL}
    />
  );
}
